import { css } from '@emotion/react'
import { fontSizes } from '@opallabs/pulsar'

export const base = css({
  color: '#8495a3',
  fontSize: fontSizes.small,
  lineHeight: '18px',
  margin: 0,
})
